import { createContext, useContext } from "react";
import type { LinkedBoard } from "../table.data.interface";
import type { ShareColumnResult } from "./shareColumn";

export interface ShareColumnContextValue {
  /** Every board the item lives on, the current one included. */
  linkedBoards: LinkedBoard[];
  currentBoardId: string;
  onShared: (result: ShareColumnResult, columnType: string) => void;
}

// Null outside the item view (and in the empty state), where the "+" must not render.
const ShareColumnContext = createContext<ShareColumnContextValue | null>(null);

export const ShareColumnProvider = ShareColumnContext.Provider;

export const useShareColumnContext = () => useContext(ShareColumnContext);
